export class MouvementDestination {
    static jsonMap = {
        id: 'id',
        code: { key: 'code', optional: true, default: '' },
        libelle: { key: 'libelle', optional: true, default: '' }
    };

    id: number = undefined;
    code: string = undefined;
    libelle: string = undefined;
}
